/**
 * PEST-RISK-LEGACY-SURFACES-FINAL-CONSISTENCY-FIX-1
 * Review-only vocabulary for the pest & disease risk signal surface.
 * No treatment, equipment, product, dose or application wording is allowed here.
 */
export const diseaseRiskEn = {
  diseaseRisk: {
    title: "Pest & disease risk signals",
    subtitle:
      "Risk signals based on weather, crop stage, GDD and available field/satellite data.",
    selectParcel: "Select parcel",
    recalculate: "Recalculate",
    activeModels: "Active models",
    howTitle: "How the risk signal is calculated",
    howBody:
      "Pest and disease risk signals are estimated from crop type, weather conditions, pest/disease rules, available satellite vegetation context, GDD when available, and field scouting when available. These are review-support signals, not an official phytosanitary diagnosis.",
    signalsAssessed: "Signals assessed",
    elevatedSignals: "Elevated signals",
    intermediateSignals: "Intermediate signals",
    calculating: "Running epidemiological models...",
    noRisks: "No significant risk signals detected",
    noRisksDesc: "Current conditions do not favour pest or disease development.",
    disease: "Disease",
    pest: "Pest",
    vulnerableStage: "Vulnerable stage",
    nonVulnerableStage: "Non-vulnerable stage",
    weatherFavorable: "Weather favourable",
    weatherNotFavorable: "Weather not favourable",
    assessmentUpdated: "Assessment updated",
    signalsAssessedCount: "signals assessed",
    gddNotUsed: "GDD available: {{value}} · not used by this rule",
    nextStepsTitle: "Allowed next steps",
    nextStepMonitor: "Continue monitoring",
    nextStepScouting: "Create a scouting record",
    nextStepAgronomist: "Review evidence with a qualified agronomist",
    nextStepsNote:
      "SentinelCrop does not suggest products, doses, applications or intervention preparation.",
    referenceOnlyNote:
      "Reference signals only. They do not replace the canonical phytosanitary status of the parcel.",
  },
};